import z from 'zod'
import { assetTaskStatusSchema } from '../ingest/types.ts'
import { parseHttpUrl } from '../lib/url.ts'

export const assetDataExtractionRunSchema = z.object({
  runId: z.string().nullish(),
  startedAt: z.coerce.date().nullish(),
  completedAt: z.coerce.date().nullish(),
  status: assetTaskStatusSchema.optional().default('UNKNOWN'),
  assetId: z.string().optional(),
  scope: z.enum(['add', 'update']).optional(),
})

export type AssetDataExtractionRunHandle = z.infer<typeof assetDataExtractionRunSchema>

export const sourceDataSchema = z.object({
  sourceWebUrl: z
    .string()
    .refine((val) => !val || parseHttpUrl(val) !== null, {
      message: 'Invalid HTTP/HTTPS URL',
    })
    .nullish()
    .optional()
    .describe('URL from which the property was originally scraped.'),
  sourceDocumentUrl: z
    .string()
    .optional()
    .describe('Path to the document that was used as the source for the property data.'),
  runs: z
    .array(assetDataExtractionRunSchema)
    .optional()
    .describe('Runs of extraction tasks for this property.'),
})

export type AssetSourceData = z.infer<typeof sourceDataSchema>
